import {
  Grid,
  Card,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  Divider,
  CardHeader,
  Typography,
} from '@mui/material';
import NoticeTableRow from './NoticeTableRow';
import { useDashboardNoticeQuery } from '../../Components/Dashboard/api/dashboardEndPoint';
import TableLoader from '../../Components/Spinner/TableLoader';

const NoticeTable = () => {
  const { allNotice, isLoading } = useDashboardNoticeQuery();
  return (
    <Box mt={5}>
      <Grid container>
        <Grid item xs={12}>
          <Card>
            <CardHeader
              title={
                <Typography
                  sx={{ fontWeight: 700, lineHeight: 1.34, fontSize: 17 }}
                >
                  Notice List
                </Typography>
              }
            />
            <Divider />
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>SL</TableCell>
                  <TableCell>Title</TableCell>
                  <TableCell>Create date</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading ? (
                  <TableLoader />
                ) : allNotice.length ? (
                  <>
                    {allNotice?.map((sNotice, index) => {
                      return (
                        <NoticeTableRow
                          index={index}
                          sNotice={sNotice}
                          key={sNotice.id}
                        />
                      );
                    })}
                  </>
                ) : (
                  <></>
                )}
              </TableBody>
            </Table>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default NoticeTable;
